export default "__VITE_ASSET__B4WBTv3h__"